"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @since 2017-05-08 21:21:23
 * @author vivaxy
 */

/**
 {
     [namespace]: {
         [name]: {
             name,
             namespace,
             displayName,
             latestVersion: [latestVersion],             // String，e.g. 0.6.1
             versions: {
                 [version]: {
                     jsUrl,
                     picUrl,
                     klass,
                     props,
                     ...
                 },
                 ...,
             }
         },
         ...
     },
     ...
 }
 * @type {{}}
 */

var componentMap = {};

exports.default = componentMap;

/**
 *
 * @param namespace
 * @param name
 * @param version
 * @returns {null|Object}
 *  - klass
 */

var getComponentFromComponentMap = exports.getComponentFromComponentMap = function getComponentFromComponentMap(namespace, name, version) {
    return componentMap[namespace][name].versions[version];
};

/**
 *
 * @param namespace
 * @param name
 * @returns {string}
 */
var getComponentDisplayNameFromComponentMap = exports.getComponentDisplayNameFromComponentMap = function getComponentDisplayNameFromComponentMap(namespace, name) {
    return componentMap[namespace][name].displayName;
};

/**
 *
 * @param namespace
 * @param name
 * @returns {string}
 */
var getComponentLatestVersionFromComponentMap = exports.getComponentLatestVersionFromComponentMap = function getComponentLatestVersionFromComponentMap(namespace, name) {
    return componentMap[namespace][name].latestVersion;
};

/**
 *
 * @param namespace
 * @param name
 * @param version
 * @param value
 * @returns {string}
 */
var setComponentMap = exports.setComponentMap = function setComponentMap(namespace, name, version, value) {
    if (!componentMap[namespace]) {
        componentMap[namespace] = {};
    }
    if (!componentMap[namespace][name]) {
        componentMap[namespace][name] = {};
    }
    if (!componentMap[namespace][name].versions) {
        componentMap[namespace][name].versions = {};
    }
    componentMap[namespace][name].versions[version] = value;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/components.js
// module id = 227
// module chunks = 0